module.exports = function() {
  return new Worker("/" + "babel-transpiler.3e5fc16b.worker.js");
};